module.exports = __webpack_public_path__ + "img/user.bf2f3e1b.png";